export * from './MindbodyLocationConfiguration';
